
import {
  SiChakraui,
  SiFirebase,
  SiJavascript,
  SiMaterialui,
  SiMongodb,
  SiExpress,
  SiTypescript,
} from "react-icons/si";
import {
  FaGitAlt,
  FaHtml5,
  FaReact,
  FaCss3Alt,
  FaBootstrap
} from "react-icons/fa";


export const education = [
  {
    title: "Masai School",
    alt: "Online Remote",
    skills: ["Full-Stack Web Development",],
    description:
      "The 9 to 9 curriculum, 6 days a week, has had a significant influence on my lifestyle; there is no room for slacking or taking casual leaves, which has taught me to work in the discipline. You are always on your toes to learn efficiently.      As a Full Stack Developer is someone who works with the Back End — or server side — of the application as well as the Front End, or client side. Full Stack Developers have to have some skills in a wide variety of coding niches, from databases to graphic design and UI/UX management in order to do their job well. They are something of a swing, ready to assist wherever needed in the process. handles the entire application.",
    period: "Dec 2021 – Dec 2022",
    logo: "https://scontent-del1-1.xx.fbcdn.net/v/t39.30808-6/278585597_3292003127686005_6223893951869428343_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=Ikryiczl9CsAX_tDJqQ&_nc_ht=scontent-del1-1.xx&oh=00_AT9LZAKUEmXvCAoiAP8MbzHGEDD0a60YZrnyyscZHFQdWw&oe=6297A82B",
  },
  {
    title: "B.Sc. in Hospitality and Hotel Administration",
    alt: "Graduation",
    skills: ["Hotel Management", "IHM Dehradun"],
    description:
      `The hospitality industry is a broad category of fields within service industry that includes event planning, lodging, transportation, theme parks, cruise line, and additional fields within the tourism industry. More apart from its glamour, good career in hotel management has become lucrative and exciting. I learned alot from this course and gained much confidance while working with people from different origins.`,
    role: "Under Graduation",
    period: "2017 – 2020",
    logo: "IHMD",
  },
  {
    title: "Class 12 (Commerce)",
    alt: "Graduation",
    skills: ["MySql", "Java NetBeans", "Computer Networking"],
    description:
      `Subjects Including : Informatics Practices, Business Studies,Accountancy,Economics and English`,
    role: "Kendriya Vidhyalaya, Delhi Cantt",
    period: "Mar 2014",
    logo: "K.V",
  },
];

export const experiences = [
  {
    title: "Digital Edge, Udaipur",
    alt: "Digital Edge",
    role: "Web Developer & Social Media Manager",
    description:
      "To create landing pages of web pages based onadvertisements. To manage social media accounts and web pages of given clients.",
    skills: [
      "Social Media Management",
      "Web Develoment",
    ],
    period: "Sept 2023 - Dec 2023",
    logo: "Digital Edge",
  },
  {
    title: "Aimed Labs, Indore",
    alt: "Panda",
    role: "Software development Intern",
    description:
      "Assisted on existing projects Learned usage of parse-server in backend Explored different platforms documentation.",
    skills: [
      "Typescript",
      "Parse Server",
    ],
    period: "MAR 2023 - MAY 2023",
    logo: "Aimed Labs",
  },
  {
    title: "Food Panda",
    alt: "Panda",
    role: "Customer Service Representative",
    description:
      "Comprehend & Respond To All Customer Queries (Through Chat) With Immediate Resolution (Real Time) To Ensure Customer Satisfaction.",
    skills: [
      "Client Relationship Management",
      "Customer Service",
    ],
    period: "NOV 2015 - JUN 2017 ",
    logo: "Food Panda",
  },
  {
    title: "Radisson Gurugram",
    alt: "Radisson Gurugram",
    role: "Industrial Trainee",
    description:
      "I most enjoyed the moment when the working conditions are tough and working long hours non stop at Food and Beverage Service at banquet and Restaurant.",
    skills: [
      "Hospitality Management",
      "Hotel Serices",
    ],
    period: "Nov 2018 - Apr 2019 ",
    logo: "Food Panda",
  },
];

export const technologies = [
  {
    name: "HTML",
    link: "https://html.com/html5/",
    icon: <FaHtml5 />,
    color: "red.600"
  },
  {
    name: "CSS",
    link: "https://www.w3.org/TR/CSS/#css",
    icon: <  FaCss3Alt
    />,
    color: "green.400"

  },
  {
    name: "React",
    link: "https://reactjs.org/",
    icon: <FaReact />,
    color: "blue.400"

  },

  {
    name: "Bootstrap",
    link: "https://getbootstrap.com/",
    icon: <FaBootstrap />,
    color: "purple.400"

  },
  {
    name: "Chakra UI",
    link: "https://chakra-ui.com/",
    icon: <SiChakraui />,
    color: "teal.400"

  },
  {
    name: "Material UI",
    link: "https://mui.com/",
    icon: <SiMaterialui />,
    color: "blue.600"

  },
  {
    name: "Javascript",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    icon: <SiJavascript />,
    color: "yellow.400"

  },
  {
    name: "Typescript",
    link: "https://www.typescriptlang.org/",
    icon: <SiTypescript />,
    color: "blue.500"

  },
  {
    name: "Git",
    link: "https://git-scm.com/",
    icon: <FaGitAlt />,
    color: "red.500"

  },
  {
    name: "Mongodb",
    link: "https://www.mongodb.com/",
    icon: <SiMongodb />,
    color: "green.600"

  },
  {
    name: "Firebase",
    link: "https://firebase.google.com/",
    icon: <SiFirebase />,
    color: "orange.500"

  },
  {
    name: "ExpressJs",
    link: "https://www.oracle.com/",
    icon: <SiExpress />,
    color: "red.500"
  },
];


export const ProjectData = [

  // {
  //   title: "Calendly.com Clone",
  //   link: "https://calendly-react-clone.netlify.app/",
  //   url: "https://github.com/satishkumarojha/adorable-crown-8253",
  //   description: "Calendly is a software company that develops a business communication platform for teams to schedule, prepare and follow up on external meetings.Made with the help of react redux and user interface is build with ChakraUI",
  //   language: ["React", " ", "Redux", " ", "ChakraUI", " ", "CalendlyApi"],
  //   image: "https://camo.githubusercontent.com/06e1a1b190508b3a5fd8e0cfc82d1ba846f15ef5996da7a2edc935268ab6fd10/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f313430302f312a4955617472696469576543522d7a48374678664246772e6a706567"
  // },
  {
    title: "cricLive",
    link: "https://cric-live.vercel.app/",
    url: "https://github.com/S-hub1996/cric_live",
    description: "This is a solo project based A platform where you can have live scores, updates, and match schedule of cricket. Made with the help of react redux and user interface is build with ChakraUI",
    language: ["React", " ", "Redux", " ", "ChakraUI", " ", "CricApi.com"],
    image: "https://user-images.githubusercontent.com/77965216/205295632-0df642d4-6990-43eb-a4be-45f8e2c33664.png"
  },
  {
    title: "Resume Builder",
    link: "https://resume-builder-cssv.vercel.app/",
    url: "https://github.com/S-hub1996/ResumeBuilder",
    description: "This is a personal project based Professional Resume Builder, with downloading in PDF format feature. Made with the help of react redux.",
    language: ["React", " ", "Redux", " ", "React-print"],
    image: "https://user-images.githubusercontent.com/94439105/175854197-45c646f0-1a11-4039-b633-efbd452075ca.png"
  },
  {
    title: "Big-basket-clone",
    link: "https://big-basket-clone-by-masai-school.netlify.app/",
    url: "https://github.com/S-hub1996/Big-basket-clone",
    description: "Online Grocery App with React.JS react-router We are in Unit-4 from Web-16 Batch students of Masai School at the end of unit Masai team is assigned a project and the project is based on the technology we are learned in the whole unit in this project we are used React-Redux and React-Router-Dom.",
    language: ["React", " ", "Redux",],
    image: "https://user-images.githubusercontent.com/94439105/171357204-0c9e4681-352b-4fc6-b5fa-ff666c5f8f1d.png"
  },
  {
    title: "Beardo.in",
    link: "https://beardoclone.netlify.app/",
    url: "https://github.com/S-hub1996/Beardo.in",
    description: "A web application to buy men's grooming products. Features: Social Sign-in/Sign-up Location-based vehicle gallery User authentication  Areas of responsibility: Built authentication and integrated it with the frontend. Laid out the database schema and build the REST API for the same. Developed the Home and Tariff page. A collaborative project built by a team of 6 executed in 4 days.",
    language: ["HTML", " ", "CSS", " ", "JavaScript"],
    image: "https://user-images.githubusercontent.com/94439105/171358153-a779e07b-54da-44f3-8783-766568f3fcff.png"
  },
  {
    title: "TATA 1MG",
    link: "https://precious-biscotti-be61c5.netlify.app/feature.html",
    url: "https://github.com/S-hub1996/project-1mg",
    description: "1mg.com brings to you an online platform, which can be accessed for all your health needs.Tata 1mg is India’s leading digital healthcare platform. - A complete detailed product page displays all the details regarding the product, here we have given the user an option to add to the cart option if he/she like to buy the product.",
    language: ["HTML", " ", "CSS", " ", "JavaScript"],
    image: "https://user-images.githubusercontent.com/94439105/171359502-4fd575c1-bb03-4620-bacc-7cc366aec911.png"
  },
  {
    title: "Tic Tac Toe",
    link: "https://dashing-bombolone-90ec44.netlify.app/",
    url: "https://github.com/S-hub1996/tictactoe",
    description: "I created 3 react components: Game, Square and a restart button. The Game component will contain 9 Squares, the restart button and a text displaying the game status — whose turn it is or who won.",
    language: "React",
    image: "https://user-images.githubusercontent.com/94439105/171418551-0d432a97-70aa-4952-8f19-5779e35611e9.png"
  },
  // {
  //   title:"Facebook Clone",
  //   link:"https://facebook-by-shub-man.netlify.app/",
  //   url:"https://facebook-by-shub-man.netlify.app/",
  //   description:"Facebook clone with ReactJs and login signup using firebase database live login by google id's used facebook plugins for live posts and dynamic posting added using reducers. ",
  //   language:["React"," ","FireBase",],
  //   image:"https://user-images.githubusercontent.com/94439105/172838887-aeb78242-1a95-4f32-a273-09dfe94e1a55.jpg"
  // },
  {
    title: "Weather Forecast",
    link: "https://masai-weekly-weather-forcast-byshubham.netlify.app/",
    url: "https://github.com/S-hub1996/weatherforcast",
    description: "Global weather forecast app using open weather API with vanilla JavaScript and Basic HTML CSS",
    language: "Vanilla Javascript",
    image: "https://user-images.githubusercontent.com/94439105/171650171-f50a2d78-1882-413a-8783-51e82d33e8d2.png"
  },
]
